import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchPortCollections, PortCollectionQueryKeys } from 'services/clients/portCollection';

interface Props {
  onChange: (port: string[]) => void;
  value: string[];
}

export const PortCollectionSelector: React.FC<Props> = (props) => {
  const portOptionsQuery = useQuery(
    [PortCollectionQueryKeys.PortCollections],
    ({ signal }) => fetchPortCollections({ pageSize: 100, isVisible: true }, signal),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return (
    <div className="space-y-4">
      <h4 className="font-medium">
        What are your main ports of operation? Select all that apply.*
      </h4>
      <ToggleButtonGroup
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2"
        onChange={(_, value) => {
          props.onChange(value);
        }}
        value={props.value}
      >
        {portOptionsQuery.data?.results.map((option) => (
          <ToggleButton key={option.code} value={option.code}>
            <h4>{option.name}</h4>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};
PortCollectionSelector.displayName = 'CreateCompany.CompanyDetails.Other.PortCollectionSelector';
